import DatePicker from '$components/DatePicker'
import Form from '$components/Form'
import OrderAddressView from '$components/OrderAddressView'
import ExpirationDate from '$components/OrderPartsListTable/ExpirationDate'
import { useUser } from '$context/user'
import { Col, Input, Row, theme } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'
import PropTypes from 'prop-types'

const { useToken } = theme
const { TextArea } = Input

const OfferAdditionalContent = ({ form, orderPartsList, editable }) => {
  const { t } = useTranslation()
  const { token } = useToken()
  const { isServiceProvider } = useUser()

  return (
    <>
      <Form
        form={form}
        layout="vertical"
        requiredMark={(label, info) => (
          <h4>
            {label}
            {info.required && (
              <span style={{ color: token.colorError, marginLeft: '5px' }}>
                *
              </span>
            )}
          </h4>
        )}
      >
        <Row>
          <Col span={16}>
            <Form.Item
              label={t('received_requests.date_of_expiration')}
              name={'date_of_expiration'}
              initialValue={
                orderPartsList?.date_of_expiration
                  ? dayjs(orderPartsList.date_of_expiration)
                  : undefined
              }
              rules={[
                {
                  required: true,
                  message: t('received_requests.date_of_expiration_required'),
                },
              ]}
            >
              {editable ? (
                <DatePicker
                  style={{ width: '45%' }}
                  disabledDate={(d) => !d || d.isBefore(new Date())}
                  allowClear={false}
                />
              ) : (
                <ExpirationDate
                  date_of_expiration={orderPartsList.date_of_expiration}
                />
              )}
            </Form.Item>
            <OrderAddressView
              billingAddress={orderPartsList.billing_address}
              deliveryAddress={orderPartsList.delivery_address}
            />
          </Col>
          <Col span={8}>
            {orderPartsList?.client_note && (
              <>
                <h4>
                  {t('service.order_part.additional_notes')}
                  {isServiceProvider && ` ${t('by customer')}`}
                </h4>
                <p>{orderPartsList?.client_note}</p>
              </>
            )}

            {isServiceProvider && orderPartsList?.operator_note && (
              <>
                <h4>{t('received_requests.operator_note')}</h4>
                <p>{orderPartsList?.operator_note}</p>
              </>
            )}

            {editable ? (
              <Form.Item
                label={t('received_requests.provider_note')}
                name={'provider_note'}
                initialValue={orderPartsList?.provider_note}
              >
                <TextArea rows={4} placeholder="" />
              </Form.Item>
            ) : (
              orderPartsList?.provider_note && (
                <>
                  <h4>
                    {t('received_requests.provider_note')}
                    {!isServiceProvider && ` ${t('by service provider')}`}
                  </h4>
                  <p>{orderPartsList?.provider_note}</p>
                </>
              )
            )}
          </Col>
        </Row>
      </Form>
    </>
  )
}

OfferAdditionalContent.propTypes = {
  form: PropTypes.object,
  editable: PropTypes.bool,
  orderPartsList: PropTypes.object,
}

export default OfferAdditionalContent
